import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export default class InvoiceRepository extends EntityBaseRepository {
    public findByRide(rideId: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`invoice/by-ride/${rideId}`);
    }
}
